import { defineComponent } from 'vue';
export default defineComponent({
  name: 'ExternalContacts',
  components: {},
  setup: function setup(props, ctx) {
    return {};
  }
});